import React, {useEffect, useRef, useState} from 'react';
import { process } from '@progress/kendo-data-query'
 import { GridPDFExport } from '@progress/kendo-react-pdf';
import {
    Grid as KGrid,
    GridColumn as Column,
    GridColumnMenuCheckboxFilter,
    GridToolbar,
} from '@progress/kendo-react-grid';
import allColumns from './columns.js'
import { groupBy } from '@progress/kendo-data-query';
import {CustomColumnMenu} from "./columnMenu";
import Button from "@material-ui/core/Button";
import {ExcelIcon} from "../../../UIComponents/icons";
import {blue, green, red} from "@material-ui/core/colors";
import PrintIcon from "@material-ui/icons/PictureAsPdfOutlined";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import PayrollExcelExport from "./excelExportPayrorollSheet";
import moment from "moment";
import {Tab, useMutation, useNotify, useQueryWithStore, usePermissions} from "react-admin";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import CircularProgress from "@material-ui/core/CircularProgress";
import MultiCurrency from "../../multiCurrency";
import {FormattedNumber} from "react-intl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Popover from '@material-ui/core/Popover';
import _ from 'lodash';
import {
    usePopupState,
    bindTrigger,
    bindPopover,
} from 'material-ui-popup-state/hooks'
import {Typography} from "../../../UIComponents/Wrappers";
import PayrollFooterItem from "./payrollFooterItem";
import OverTimeItem from "../../dialogs/overTimeItem";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import SettingIcon from "@material-ui/icons/SettingsOutlined"

import  {useStore, Provider} from "react-redux";
import {getImageDimensions} from "../../../Helpers/b64toBiteArray";
import PayrollJournal from "../journal/payrollJournal";
import Zemen from "../../../UIComponents/ZemenCalendar/zemen";
import {multiDateFun} from "../../../Helpers/multiDateFun";
import columns from "./columns.js";
import NumberCell from '../../../UIComponents/NumberCell.js';
function getExcelColumnLetter (cols) {
    if(cols<=26)
    return String.fromCharCode(64 + cols)
    else
        return `A${String.fromCharCode(64 + cols%26)}`
}





const MultiCurrencyCell = ({dataItem,field,columnIndex, format, pdf,rowType,columns, className, scale=0.4, pdfFontSize=12}) => {
    // console.log({rest})
    const value = dataItem[field];
    if (rowType === "groupFooter") {
        if(field==='_fullName') {
            return (
                <td aria-colindex={columnIndex}>
                    {dataItem.aggregates[field].count}
                </td>
            );
        }
        if (columns.filter(c=>c.format==="{0:n2}").map(c=>c.field).includes(field)&&dataItem.aggregates[field]) {
            return (
                <td aria-colindex={columnIndex}>
                   {pdf?<NumberCell scale={scale} pdfFontSize={pdfFontSize} value={dataItem.aggregates[field].sum}/>: <MultiCurrency value={dataItem.aggregates[field].sum}/>}
                </td>
            );
        }
    }
    return (
        <td className={className}>
            {/*<Provider store={'../'}>*/}
            {(!isNaN(value)&& format==='{0:n2}')?!pdf?<MultiCurrency value={value}/>:<NumberCell scale={scale} pdfFontSize={pdfFontSize} value={value}/>:<span style={pdf?{fontSize:`${pdfFontSize}px`}:{}}>{value}</span>}
            {/*</Provider>*/}
        </td>
    );



};

// In a separate file, or at the top of your component
const DynamicHeaderCell = (props) => {
    const { pdf, pageScale, pdfFontSize, ...restProps } = props; // Destructure your custom props
    const baseFontSize = 1; // e.g., 1em for UI, or a base for PDF
    let calculatedFontSize = baseFontSize;
  
    if (pdf) {
      // Adjust font size based on pageScale for PDF
      // You'll need to fine-tune this logic based on how pageScale affects your visual output.
      // pageScale is a value like 0.25, 0.5, 0.75, 1.0, 1.5 etc.
      // A smaller scale might need a relatively larger font size to be legible, or vice versa.
      // Experiment with this formula!
      calculatedFontSize = pdfFontSize ? pdfFontSize / 12 : baseFontSize / pageScale * 0.5; // Use the specified pdfFontSize if provided
      // Or perhaps simpler, just multiply if pageScale acts like a global zoom:
      // calculatedFontSize = baseFontSize * pageScale * 1.5; // Example: Smaller font for smaller scale
      // You might want to cap it to a reasonable min/max
      calculatedFontSize = Math.max(1, Math.min(3, calculatedFontSize)); // Example min/max
    }
  
    return (
      <th
        {...restProps.ariaAttributes}
        style={{
          fontSize: `${calculatedFontSize}em`, // Apply calculated font size
          // Inherit or set other styles as needed
          
          fontWeight: 'bold',
          textWrap:'wrap',
          verticalAlign: 'top', // Apply here
          border:'none',
        }}
        className={pdf ? 'k-pdf-export-header' : ''} // Optional: add a class for further CSS specificity
      >
        <div style={pdf?{height:'150px'}:{}}>
        {props.title}
        </div>
        
        {restProps.children} {/* IMPORTANT: Render Kendo's default header content (sorting, menu) */}
      </th>
    );
  };

//
// const initialDataState = {
//     skip: 0,
//     take: 50,
// };
const PayrollSheetGrid = ({data,fileName,region,site,department,employmentType,logo, stamp, templates,payrollRun,scroll="scrollable", calendar, onSeparateByCostCenter,companySettings, allUsers}) => {
  
    const toFullName = (userName) => {
        // console.log(allUsers)
        const user = allUsers.find(function(u) { return u.username === userName });
        return user ? ((user.firstName||'') + " " + (user.lastName||'')) : userName;
    };

    const getSign = (userName) => {
        const user = allUsers.find(function(u) { return u.username === userName });
        return user ? ((user.signatureImage)): '';
    }

    const getUniqueReviewers = (payrollRun) => {
    const logs = (payrollRun && payrollRun.auditLogMeta) || [];

  
    
    // Backward compatibility: If no logs have a payrollId, we skip the ID check
    const hasNewSystemLogs = logs.some(a => Object.prototype.hasOwnProperty.call(a, 'payrollId'));
  console.log(payrollRun, hasNewSystemLogs)
    return _.uniqBy(
        logs.filter(a => {
            const isTypeMatch = a.type === 'Reviewed';
            // console.log({a})
            const idMatches = !hasNewSystemLogs || a.payrollId === payrollRun.id;
            return isTypeMatch && idMatches;
        }), 
        'user'
    )
  //  .filter(r => r.user !== payrollRun.createdBy)
    .map(r => ({ 
        name: toFullName(r.user), 
        sign: getSign(r.user) 
    }));
};


    const [defaultFooterElements, setDefaultFooterElements] = useState([
        { field: "Prepared By", value: toFullName(payrollRun.createdBy), sign: getSign(payrollRun.createdBy) },
        { field: "Reviewed By", value: getUniqueReviewers(payrollRun) },
        { field: "Checked By", value: toFullName(payrollRun.checkedBy), sign: getSign(payrollRun.checkedBy) },
        { field: "Approved By", value: toFullName(payrollRun.approvedBy), sign: getSign(payrollRun.approvedBy) }
    ]);

    useEffect(function() {
        setDefaultFooterElements([
            { field: "Prepared By", value: toFullName(payrollRun.createdBy), sign: getSign(payrollRun.createdBy) },
            { field: "Reviewed By", value: getUniqueReviewers(payrollRun) },
            { field: "Checked By", value: toFullName(payrollRun.checkedBy), sign: getSign(payrollRun.checkedBy) },
            { field: "Approved By", value: toFullName(payrollRun.approvedBy), sign: getSign(payrollRun.approvedBy) }
        ]);
    }, [allUsers, payrollRun]);

    console.log({defaultFooterElements})
  
    const [showFooter,setShowFooter] = useState(false);
    const [showJournal,setShowJournal] = useState(false);
    const [footerItems,setFooterItems] = useState(defaultFooterElements)
    const [columnsId,setColumnsId] = useState();
    const [pageSize,setPageSize] = useState("A4");
    const [pageScale,setPageScale] = useState(0.5);
    const [pdfFontSize, setPdfFontSize] = useState(12);

    const permissions= usePermissions()
    // const [page, setPage] = useState(initialDataState);
    const [pageSizeValue, setPageSizeValue] = useState();
    // const pageChange = (event) => {
    //     console.log({event})
    //     // const targetEvent = event.targetEvent;
    //     const take = event.page.take || 500
    //
    //       //  setPageSizeValue(event.page);
    //
    //     setPage({
    //         ...event.page,
    //         take,
    //     });
    // };

    const store = useStore();
    // console.log('y',companySettings)
    const popupState = usePopupState({
        variant: 'popover',
        popupId: 'demoPopover',
    })
    const { loaded, error} = useQueryWithStore({
            type: 'getList',
            resource: 'payrollReportSettings',
        },{
            onSuccess: (res) =>{

              //  console.log(res)
                if(res.data[0])
                {

                    setShowFooter(!!res.data[0].showFooter)
                    setShowJournal(!!res.data[0].showJournal)
                    if(res.data[0].footers && res.data[0].footers.length) {
                        setFooterItems(footerItems.filter(f=>res.data[0].footers.map(i=>i.field).includes(f.field)))
                    }
                    setPageSize(res.data[0].pageSize)
                    setPageScale(res.data[0].pageScale)
                    setPdfFontSize(res.data[0].pdfFontSize || 12)
                    setColumnsId(res.data[0].id)
                    if(res.data[0].columns&&res.data[0].columns.length) {
                        setColumns(res.data[0].columns)
                    }
                    if(!!res.data[0].groupBy&&res.data[0].groupBy.length) {
                        setDataState({...dataState,group:res.data[0].groupBy.map(g=>({field:g,aggregates}))})
                        setResult(process(data.slice(0),{...dataState,group:res.data[0].groupBy.map(g=>({field:g,aggregates}))}))
                       // console.log(res.data[0].groupBy)
                        if(res.data[0].groupBy.includes('costCenterCode')) {
                            onSeparateByCostCenter()
                        }
                    }
                }
            }
        }
    );





    const [columns,setColumns0] = useState(allColumns(templates,companySettings));
    const [aggregates,setAggregates] = useState([{
        field: '_fullName',
        aggregate: "count",
    }].concat(allColumns(templates).filter(c=>c.format==="{0:n2}").map(c=>( {
        field: c.field,
        aggregate: "sum",
    }))));
    const setColumns = (cols)=>{

        setColumns0(cols)
        setAggregates([{
            field: '_fullName',
            aggregate: "count",
        }].concat(cols.filter(c=>c.format==="{0:n2}").map(c=>( {
            field: c.field,
            aggregate: "sum",
        }))))
    }

    // const [columnSizes,setColumnSizes] = useState(allColumns(templates));
   let gridPDFExport ;//= useRef();
    const exportExcel = useRef();
    const [exporting,setExporting] = useState();
    // const aggregates = [
    //     {
    //         field: "basicSalary",
    //         aggregate: "sum",
    //     },
    // ]
    const [dataState,setDataState] = useState({

        group:

            [
                // { field: 'costCenterCode',aggregates }
            ],
        skip: 0,
        take: 1000,

    })

    const [result,setResultF] = useState(process(data.slice(0), dataState))
    const setResult  = result => {
        const r = _.cloneDeep(result)
        // console.log({r})
        if(r.data && r.data[0] && r.data[0].field) {
            r.data.forEach(d=>{
                // console.log({d})
                d.items && d.items.forEach((i,index)=>{
                    i.sn=index+1
                })
            })
        }
        setResultF(r)
    }
    useEffect(() => {
   //     if (data !== data) {

            setResult(process(data.slice(0), dataState))


      //  }
    }, [data]);

    const [mutate, { loading }] = useMutation();
    const notify = useNotify();
    const [columnSizes,setColumnSizes] = useState({});
    const updateColumnsWidth = () => {
        // cols = cols.map(c=>({..._.omit(c,"newWidth"), width: c.newWidth}))
        // setColumns(cols)
       // console.log(columns)
       const cols =  columns.map(c=>{
            if(columnSizes[c.field])
            {
                return ({...c,width:columnSizes[c.field]})
            }
            return  c;
        })
        setColumns(cols)
        return cols;

    }
    const saveColumns = ()=> mutate({
            type: columnsId?'update':'create',
            resource: `payrollReportSettings`,
            payload: {
                id: columnsId,
                data: {
                    columns: updateColumnsWidth(),
                    showFooter,
                    showJournal,
                    footers: footerItems.map(function(f) {
                        return _.omit(f, 'sign','value');
                    }),
                    pageScale,
                    pageSize,
                    pdfFontSize,
                    groupBy: dataState.group.map(function(g) { return g.field; })
                }
            }
        },
        {
            onSuccess: ({ data }) => {
                //console.log(data)


                notify('Payroll Sheet View Saved for next time');
                //setOpen(false)
              //  refresh()
            },
            onFailure: (error) => notify(`Unable to save this view`, 'warning'),
        });


    // const processWithGroups = (data, dataState) => {
    //     const newDataState = process(data, dataState);
    //     setGroupIds({
    //         data: newDataState.data,
    //         group: dataState.group,
    //     });
    //     return newDataState;
    // };



    const dataStateChange = (event) => {
        console.log({event})
        const groups = event.data.group;

        if (groups) {
            groups.map((group) => (group.aggregates = aggregates));
        }

        event.data.group = groups;
        setDataState(event.data)
        setResult(process(data.slice(0), event.data))
       // this.setState(this.createDataState(event.data));
    }
    const onColumnsSubmit = (columnsState) => {
        setColumns(columnsState)
    }
    const exportPDF = () => {
       gridPDFExport.save(result, pdfExportDone);
       setExporting(true)
        //this.setState({ exporting: true });
    }

    const loadLogosAndExportToExcel = () => {
           updateColumnsWidth()
       // const payDayLogo = 'data:image/png;base64,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'
        const url = logo; //"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="
if(url) {
    fetch(url)
        .then(res => res.arrayBuffer())
       // .then(x=>console.log(JSON.stringify(x)))
        .then(data => getImageDimensions(url).then(dim=>exportToExcel({logo: {type: "image/png", data,dim}})))
}
        else {
    exportToExcel();
}
    }

    const exportToExcel = (images) => {
        const options = exportExcel.current.workbookOptions();

        options.creator = "payday.truwrk.com"
        const sheet = options.sheets[0];
        options.sheets[1] = {rows:[],
            columns: [
                { width: 100 }, {  width: 100}, { width: 300 },  { width: 150 }, { width: 100 }, { width: 300 },{ width: 150 },{},{},{},{width:150}
            ],}
        const sheet2= options.sheets[1];
        sheet2.name = "Payroll Journal";
        if(images){
            options.images = images;
            sheet.drawings = [
                {
                    topLeftCell: "A1",
                    offsetX: 32,
                    offsetY: 10,
                    width: (images["logo"].dim.w/images["logo"].dim.h)*100,
                    height: 100,
                    image: "logo"
                },
            ]
        }
       // sheet.images

        const cols = columns.filter(c=>c.show).length+1;

        sheet.frozenRows = 3;
        sheet.mergedCells = [`A1:${getExcelColumnLetter(cols-1)}1`,`A2:${getExcelColumnLetter(cols-1)}2`];
        sheet2.mergedCells = [`A1:L1`,`A2:L2`];

        //console.log(sheet.mergedCells,cols)
        /// sheet.mergedCells = ["A2:G2"];
        sheet.name = "PayrollSheet";

        var company = [{
            value:localStorage.getItem('companyName'),
            fontSize: 34,
            textAlign: "center",
            background:"#098EF6",
            color:"#ffffff",
            bold:true
        },{
            value:'',
            verticalAlign:"bottom",
            fontSize: 15,
            textAlign: "right",
            background:"#098EF6",
            color:"#ffffff",
            bold:true
        }];

        var sheetTitle = [{
            value:`${multiDateFun(calendar,payrollRun.payrollDate,'MMMM YYYY')} Payroll ${employmentType?`- ${employmentType} Employees`:''}  ${site?`- ${site} Site`:''} ${region?`- ${region} Region`:''} ${department?`- ${department} Department`:''}`,
            verticalAlign:"top",
            fontSize: 32,
            textAlign: "center",
            background:"#098EF6",
            color:"#ffffff",
            bold:true
        },{
            value:'payday.truwrk.com',
            verticalAlign:"bottom",
            fontSize: 15,
            textAlign: "right",
            background:"#098EF6",
            color:"#ffffff",
            bold:true
        }];

        const rows = sheet.rows;

        let altIdx = 0;
        rows.forEach((row) => {
            // console.log(row.type)
            if(row.type === 'header')
            {
                row.height = 80
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 22
                    cell.background="#BAD8FC"
                    cell.color = "#000"
                    cell.wrap = true
                    cell.bold = true


                });

            }
            if(row.type === 'footer')
            {
                row.height = 40
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:2}
                    cell.borderTop={size:2}
                    cell.fontSize = 28
                    cell.background="#E5E7E7"
                    cell.color = "#000"
                    cell.bold = true


                });

            }

            if(row.type === 'group-header')
            {
                row.height = 40
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 22
                    cell.background="#BAD8FC"
                    cell.color = "#000"
                    cell.wrap = true
                    cell.bold = true


                });

            }

            if(row.type === 'group-footer')
            {
                row.height = 40
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.fontSize = 28
                    cell.background="#E5E7E7"
                    cell.color = "#000"
                    cell.bold = false


                });

            }


            if (row.type === 'data') {
                // if (altIdx % 2 !== 0) {
                //     row.cells.forEach((cell) => {
                //         cell.background = '#aabbcc';
                //     });
                // }
                // altIdx++;
                row.height = 70
                row.cells.forEach((cell) => {
                    cell.borderLeft={size:1}
                    cell.borderRight={size:1}
                    cell.borderBottom={size:1}
                    cell.borderTop={size:1}
                    cell.wrap = true
                    cell.fontSize = 30

                });
            }
        });

        sheet.rows.splice(0, 0, { cells: sheetTitle, height: 55});
        sheet.rows.splice(0, 0, { cells: company, height: 55});

        sheet2.rows.splice(0, 0, { cells: sheetTitle, height: 55});
        sheet2.rows.splice(0, 0, { cells: company, height: 55});
        // var bottomCells = [
        //     [],
        //     {
        //     value:"Prepared By",
        //     fontSize: 28,
        //     textAlign: "right",
        //         bold:true,
        // },
        //     {
        //         value:"______________",
        //         fontSize: 28,
        //         textAlign: "left",
        //         bold:true,
        //     },
        //     [],
        //     {
        //         value:"Checked By",
        //         fontSize: 28,
        //         textAlign: "right",
        //         bold:true,
        //     },
        //     {
        //         value:"______________",
        //         fontSize: 28,
        //         textAlign: "left",
        //         bold:true,
        //     },
        //
        //     [],
        //     {
        //         value:"Approved By",
        //         fontSize: 28,
        //         textAlign: "right",
        //         bold:true,
        //     },
        //     {
        //         value:"______________",
        //         fontSize: 28,
        //         textAlign: "left",
        //         bold:true,
        //     },
        //
        //
        //
        // ];

        sheet.rows.push({cells:[], height:75})
        /// start journal
        payrollRun.journalEntries.map(j=>{
            let journalHeaderRow = {cells:[
                    [],
                    {
                        value:`${j.description}`,
                        fontSize: 30,
                        bold:true,
                        textAlign: "left",

                    },

                ],height:50}
            let debitRows = []
                j.debit.forEach(r=> {


                    debitRows.push({
                        cells: [
                            [],
                            [],
                            {
                                value: `${r.code || r.accountCode} - ${r.accountName}:`,
                                fontSize: 28,
                                textAlign: "left",

                            },
                            {
                                value: r.amount,
                                fontSize: 28,
                                textAlign: "right",

                                format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
                            }
                        ], height: 50
                    })
                    if(j.isCompany) {
                        payrollRun.journalEntries.filter(jr=>jr.costCenterCode).forEach(jr=>{
                            const acc =  jr.debit.find(jd=>jd.accountCode===r.accountCode)||{}

                            if(acc) {
                                debitRows.push({
                                    cells: [
                                        [],
                                        [],
                                        {
                                            value: `${acc.code || acc.accountCode} - ${acc.accountName}:`,
                                            fontSize: 28,
                                            textAlign: "right",

                                        },
                                        {
                                            value: acc.amount,
                                            fontSize: 28,
                                            textAlign: "right",

                                            format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
                                        }
                                    ], height: 50
                                })
                            }
                        })
                    }



                });


            let creditRows =
                j.credit.map(r=>({
                    cells:[
                        [],
                        [],
                        [],
                        [],
                        [],
                        {
                            value:`${r.code||r.accountCode} - ${r.accountName}:`,
                            fontSize: 28,
                            textAlign: "left",

                        },
                        {
                            value:r.amount,
                            fontSize: 28,
                            textAlign: "right",

                            format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
                        }
                    ], height:50
                }));


            // let companySummeryRows =




            const balanceRow = {cells:[
                    [],
                    [],
                    [],
                    {
                        value:   j.debit.reduce((sum,cv)=>sum+cv.amount,0),
                        fontSize: 28,
                        textAlign: "right",
                        bold:true,
                        format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
                    },
                    [],
                    [],
                    {
                        value:j.credit.reduce((sum,cv)=>sum+cv.amount,0),
                        fontSize: 28,
                        textAlign: "right",
                        bold:true,
                        format: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)'
                    },
                ],height:50}

            if(showJournal) {
                sheet.rows.push(journalHeaderRow)
                debitRows.forEach(r => sheet.rows.push(r))
                creditRows.forEach(r => sheet.rows.push(r))
                sheet.rows.push(balanceRow)
                sheet.rows.push({cells: [], height: 75})
            }

            sheet2.rows.push(journalHeaderRow)
            debitRows.forEach(r=>sheet2.rows.push(r))
            creditRows.forEach(r=>sheet2.rows.push(r))
            sheet2.rows.push(balanceRow)
            sheet2.rows.push({cells:[], height:75})

        })


        /// end journal




        let footerCells = []
        footerItems.forEach(f=>{
            footerCells = [ ...footerCells, [],
                {
                    value:`${f.field}:`,
                    fontSize: 28,
                    textAlign: "right",
                    bold:true,
                },
                {
                    value:`_${f.value?f.value:'____'}_`,
                    fontSize: 28,
                    underline:true,
                    wrap:true,
                    textAlign: "left",
                    // bold:true,
                },]
        })
        if(showFooter) {


            sheet.rows.push({cells: footerCells, height: 50})
        }





        if(showFooter) {


            sheet2.rows.push({cells: footerCells, height: 50})
        }


        exportExcel.current.save(options);


    }
    const pdfExportDone = () => {
        setExporting(false)
    }


    const TotalCell = (props) => {
        const { pdfFontSize } = props;
        // console.log(result)
        // const items = []
        // result.data.forEach(d=>d.items&&items.push(...d.items))
        const items = result.data[0]&&result.data[0].items?result.data.flatMap(x => x.items&&[...x.items]):result.data;
         const value = props.count?items.length:items.reduce((acc, current) => acc + current[props.field]||0, 0);
        //const max = products.reduce((acc, current) => Math.max(acc, current[props.field]), 0);

        return (
            <td colSpan={props.colSpan}  style={{fontSize:'small'}}>
                {/*{(+value.toFixed(props.count?0:2)).toLocaleString()}*/}
                {props.count?<span style={props.pdf?{fontSize:'1.5em'}:{}}>{value}</span>:props.pdf?<NumberCell scale={props.scale} pdfFontSize={props.pdfFontSize} value={value}/>:<MultiCurrency value={value}/>}
            </td>
        );
    }

    const handleFooterItemChange = index => ot => {
        const newRoles = footerItems.slice(0); // Create a shallow copy of the roles
        newRoles[index] = ot; // Set the new value
        setFooterItems(newRoles)
    }

    const handleRemoveFooterItem = index => () => {
        const newItems = footerItems.slice(0); // Create a shallow copy of the roles
        newItems.splice(index,1)
        setFooterItems(newItems)
    }

    const cellRender = (tdElement, cellProps) => {
       if (cellProps.rowType === "groupFooter") {
            if (cellProps.field === "value") {
                return (
                    <td aria-colindex={cellProps.columnIndex} role={"gridcell"}>
                        Basic: {cellProps.dataItem.aggregates.basicSalary.sum}
                    </td>
                );
            }
        }

        return tdElement;
    };


    const grid =  <KGrid
        className='payroll-sheet'
        reorderable={true}
        // filterable={true}

        // style={{fontSize:'large'}}
        data={result}
        {...dataState}
        onDataStateChange={dataStateChange}
        groupable={{
            footer: "visible",
        }}
        scrollable={scroll}
        sortable={true}
        resizable={true}
        onColumnReorder={e=>{
            const lookUpColumns  = _.keyBy(e.columns,'field')
            // console.log({lookUpColumns})
            setColumns(columns.map(c=>{
               // console.log(c.field)
                if(c.show ) {
                    c.orderIndex =lookUpColumns[c.field] && lookUpColumns[c.field].orderIndex

                }
                return c
            }))
        }}
        onColumnResize={e=> {
          //  console.log(e)
            const col = e.columns[e.index];
           setColumnSizes(prev=>({...prev,[col.field]:e.newWidth}));
           // const actualCol = columns.find(e=>e.field===col.field)
           // cols = columns.map(c=>{
           //      if(c.field===col.field){
           //         // console.log(c.field,e.newWidth)
           //          return ({...c,newWidth:e.newWidth})
           //      }
           //      return c
           //  })

          // console.log(cols)
          //  setColumns(cols)
        }}

        total={result.length}
        pageable={{
            buttonCount: 4,
            pageSizes: [10, 100, 1000, "All"],
            pageSizeValue: pageSizeValue,
        }}
        // onPageChange={pageChange}
        // cellRender={cellRender}
        // pageable={true}
        // pageSize={8}
    >
        <GridToolbar   >
            <Grid className='no-print' spacing={3} container>
                <Grid item><Button variant="outlined" color="primary"
                                   startIcon={<ExcelIcon style={{color: green[500]}}/>}
                                   onClick={loadLogosAndExportToExcel}>Export to Excel</Button></Grid>

                <Grid item>
                    <Select variant="outlined" color="primary"
                           input={<OutlinedInput margin='dense'/>}
                           value={pageSize}
                           onChange={ev => {
                               setPageSize(ev.target.value)
                               //  setFilteredPayrolls(props.filteredPayrolls.filter(p=>ev.target.value===0||p.bank===ev.target.value))
                               // payrollRun.filteredPayrolls=filteredPayrolls
                               //   props.onChange({type:ev.target.value,hrs})
                           }}
                >
                    <MenuItem key={0} value={"A4"}>A4</MenuItem>
                    <MenuItem key={1} value={"A3"}>A3</MenuItem>
                    <MenuItem key={2} value={"A2"}>A2</MenuItem>
                    <MenuItem key={3} value={null}>Fit All</MenuItem>
                </Select>
                </Grid>
                <Grid item>
                    <Select variant="outlined" color="primary"
                           input={<OutlinedInput margin='dense'/>}
                           value={pdfFontSize}
                           onChange={ev => {
                               setPdfFontSize(ev.target.value)
                           }}
                >
                    <MenuItem key={1} value={8}>8px</MenuItem>
                    <MenuItem key={2} value={10}>10px</MenuItem>
                    <MenuItem key={3} value={12}><strong>12px</strong></MenuItem>
                    <MenuItem key={4} value={14}>14px</MenuItem>
                    <MenuItem key={5} value={16}>16px</MenuItem>
                    <MenuItem key={6} value={18}>18px</MenuItem>
                    <MenuItem key={6} value={20}>20px</MenuItem>
                    <MenuItem key={6} value={22}>22px</MenuItem>
                    <MenuItem key={6} value={24}>24px</MenuItem>
                                      <MenuItem key={6} value={26}>26px</MenuItem>
                                                        <MenuItem key={6} value={28}>28px</MenuItem>
                                                                          <MenuItem key={6} value={30}>30px</MenuItem>
                </Select>
                    {/*<Autocomplete*/}
                    {/*    id="free-solo-demo"*/}
                    {/*    value={"25"}*/}
                    {/*    freeSolo*/}
                    {/*    options={['25','50','75','100']}*/}
                    {/*    renderInput={(params) => (*/}
                    {/*        <TextField   {...params} onChange={e=>console.log(e.target.value)} label="Page Scale %" margin="dense" variant="outlined" />*/}
                    {/*    )}*/}
                    {/*/>*/}


                    <Select variant="outlined" color="primary"
                            input={<OutlinedInput margin='dense'/>}
                            value={pageScale}
                            onChange={ev => {
                                setPageScale(ev.target.value)
                                //  setFilteredPayrolls(props.filteredPayrolls.filter(p=>ev.target.value===0||p.bank===ev.target.value))
                                // payrollRun.filteredPayrolls=filteredPayrolls
                                //   props.onChange({type:ev.target.value,hrs})
                            }}
                    >
                       <MenuItem key={1} value={0.15}>15%</MenuItem>
<MenuItem key={2} value={0.20}>20%</MenuItem>
<MenuItem key={3} value={0.25}><strong>25%</strong></MenuItem>
<MenuItem key={4} value={0.30}>30%</MenuItem>
<MenuItem key={5} value={0.35}>35%</MenuItem>
<MenuItem key={6} value={0.40}>40%</MenuItem>
<MenuItem key={7} value={0.45}>45%</MenuItem>
<MenuItem key={8} value={0.50}><strong>50%</strong></MenuItem>
<MenuItem key={9} value={0.55}>55%</MenuItem>
<MenuItem key={10} value={0.60}>60%</MenuItem>
<MenuItem key={11} value={0.65}>65%</MenuItem>
<MenuItem key={12} value={0.70}>70%</MenuItem>
<MenuItem key={13} value={0.75}><strong>75%</strong></MenuItem>
<MenuItem key={14} value={0.80}>80%</MenuItem>
<MenuItem key={15} value={0.85}>85%</MenuItem>
<MenuItem key={16} value={0.90}>90%</MenuItem>
<MenuItem key={17} value={0.95}>95%</MenuItem>
<MenuItem key={18} value={1.00}><strong>100%</strong></MenuItem>
<MenuItem key={19} value={1.10}>110%</MenuItem>
<MenuItem key={20} value={1.20}>120%</MenuItem>
<MenuItem key={21} value={1.30}>130%</MenuItem>
<MenuItem key={22} value={1.40}>140%</MenuItem>
<MenuItem key={23} value={1.50}>150%</MenuItem>
                    </Select>
                <Button variant="outlined" disabled={exporting} color="primary"
                           startIcon={<PrintIcon style={{color: red[500]}}/>} onClick={()=>{

                    exportPDF()
                }}>{exporting&&<CircularProgress disableShrink
                    style={{marginLeft: -30}} size={25}/>}Export
                    PDF</Button></Grid>
                <Grid item>
                    

                    <FormControlLabel
                        control={
                            <Switch
                                checked={showFooter}
                                onChange={ev=>setShowFooter(ev.target.checked)}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Show Footer"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={showJournal}
                                onChange={ev=>setShowJournal(ev.target.checked)}
                                name="checkedJ"
                                color="primary"
                            />
                        }
                        label="Show Journal"
                    />
                </Grid>
                <Grid item><Button variant="outlined" color="primary" startIcon={<SaveIcon style={{color: blue[500]}}/>}
                           onClick={()=>{
                             //  updateColumnsWidth();
                               saveColumns();
                           }}>  Save View</Button></Grid>
            </Grid>
            {/*<button*/}
            {/*    title="Export PDF"*/}
            {/*    className="k-button k-primary"*/}
            {/*    onClick={exportPDF}*/}
            {/*    disabled={exporting}*/}
            {/*>*/}
            {/*    Export PDF*/}
            {/*</button>*/}
        </GridToolbar>

        {
            columns.map((column, idx) =>
                column.show && (<Column
                    key={idx}
                    className={column.field}
                    field={column.field}
                    title={column.title}
                    width={column.width}
                    format={column.format}
                    orderIndex={column.orderIndex}
                    cell={props=><MultiCurrencyCell {...props} columns={columns} format={column.format}/>}
                    footerCell={column.field.includes("fullName")?props=><TotalCell {...props}  count/>:column.format&&TotalCell}
                    headerCell={(props) => (
                        <DynamicHeaderCell {...props}  pageScale={pageScale} />
                      )}
                    filter={column.filter}
                    columnMenu={

                        props =>
                            <CustomColumnMenu
                                {...props}

                                filterOn={!!column.filter}
                                columns={columns}


                                initColumns={allColumns(templates,companySettings)}
                                onColumnsSubmit={onColumnsSubmit}
                            />
                    }
                />)
            )
        }
    </KGrid>
    return (
        <div >
            <PayrollExcelExport  columns={columns} templates={templates} ref={exportExcel} group={dataState.group} result={result} fileName={`${fileName}.xlsx`}/>


            <div style={{ width: pageSize&&`${(pageSize==='A4'?20:pageSize==='A3'?30:40) / pageScale}cm`}}>
                {grid}
                {/*<div style={{position:'absolute' }}>*/}
                {/*    {grid}*/}
                {/*</div>*/}
                {/*{pageSize&&<div className='no-print' style={{*/}
                {/*    position: 'absolute', width: `${(pageSize==='A4'?21:42) / pageScale}cm`,*/}
                {/*    height: "21cm", borderStyle: 'ridge', pointerEvents: 'none'*/}
                {/*}}>*/}

                {/*</div>}*/}
                {
                    !!showJournal&&
                        <div style={{maxWidth:800, marginTop:40}}>
                            <h4>Payroll Journal Entries</h4>
                    <PayrollJournal asFooter readOnly   payrollRun={payrollRun} templates={templates} />
                        </div>

                }
                {!!showFooter&&<footer style={{marginTop: 50}}>
                   {permissions.loaded && permissions.permissions.includes('Manager')&&<div className="no-print"  >

                        <IconButton color="primary" {...bindTrigger(popupState)}>

                            <SettingIcon/>
                        </IconButton>
                        <Popover
                            {...bindPopover(popupState)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                  
                            <Typography >
                                {footerItems.map((f,index)=>{
                                    return <PayrollFooterItem value={f.value} field={f.field}  onRemove={handleRemoveFooterItem(index)}  onChange={handleFooterItemChange(index)} />
                                })}
                                <Button onClick={()=>setFooterItems(defaultFooterElements)} color="primary">
                                    Reset
                                </Button>

                                <Button onClick={()=>setFooterItems([...footerItems,{}])} color="primary">
                                    Add
                                </Button>



                            </Typography>
                        </Popover>
                    </div>}
                    <Grid justify="center" alignItems='center' container spacing={10} style={{marginBottom:50}}>

                        {
                            footerItems.map(fe => <Grid item>
                                    <strong>{fe.field}</strong> : <span
                                    style={{textDecoration: 'underline',zIndex:50}}>
                                        {
                                            typeof fe.value === 'string' || typeof fe.value === 'undefined' || fe.value === null
                                                ? (fe.value || '________') + '_______'
                                                : fe.value.map(i=>
                                                    <span>
                                                        {i.name || '________'}_______
                                                        {i.sign && <img style={{marginLeft:-80, marginBottom: -50, zIndex:0}} alt='sign' src={i.sign} height={120} width={120} />}
                                                    </span>
                                                )
                                        }
                                    </span>
                                    {fe.sign&&<img style={{marginLeft:-80, marginBottom: -50, zIndex:0}} alt='sign' src={fe.sign} height={120} width={120} />}
                                </Grid>
                            )
                        }

                    </Grid>



                </footer>}


            </div>


            <GridPDFExport repeatHeaders
                           pageTemplate={(props)=><PageTemplate {...props} footerItems={footerItems} status={payrollRun.status} showFooter={showFooter} logo={logo} stamp={stamp} site={site} department={department} dateText={moment(payrollRun.payrollDate).format('MMMM YYYY')} />}
                           paperSize={pageSize}
                           creator={localStorage.getItem('user')+"on payday.et"}
                            fileName={`${fileName}.pdf`}
                             margin={{top: "2.25cm",left:"0.5cm",right:"0.5cm",bottom:"2.25cm"}}
                            scale={pageScale}
                           title={`${moment(payrollRun.payrollDate).format('MMMM YYYY')} ${site||''} ${department||''}`}
                            landscape={!!pageSize} ref={pdfExport => gridPDFExport = pdfExport}>

<KGrid
       style={{position:'relative', zIndex:50}}
        className='payroll-sheet-pdf'
        reorderable={true}
        // filterable={true}

        // style={{fontSize:'large'}}
        data={result}
        {...dataState}
        onDataStateChange={dataStateChange}
        groupable={{
            footer: "visible",
        }}
        scrollable={scroll}
        sortable={true}
        resizable={true}
        onColumnReorder={e=>{
            const lookUpColumns  = _.keyBy(e.columns,'field')
            // console.log({lookUpColumns})
            setColumns(columns.map(c=>{
               // console.log(c.field)
                if(c.show ) {
                    c.orderIndex =lookUpColumns[c.field] && lookUpColumns[c.field].orderIndex

                }
                return c
            }))
        }}
        onColumnResize={e=> {
          //  console.log(e)
            const col = e.columns[e.index];
           setColumnSizes(prev=>({...prev,[col.field]:e.newWidth}));
           // const actualCol = columns.find(e=>e.field===col.field)
           // cols = columns.map(c=>{
           //      if(c.field===col.field){
           //         // console.log(c.field,e.newWidth)
           //          return ({...c,newWidth:e.newWidth})
           //      }
           //      return c
           //  })

          // console.log(cols)
          //  setColumns(cols)
        }}

        total={result.length}
        pageable={{
            buttonCount: 4,
            pageSizes: [10, 100, 1000, "All"],
            pageSizeValue: pageSizeValue,
        }}
        // onPageChange={pageChange}
        // cellRender={cellRender}
        // pageable={true}
        // pageSize={8}
    >
        <GridToolbar   >
            <Grid className='no-print' spacing={3} container>
                <Grid item><Button variant="outlined" color="primary"
                                   startIcon={<ExcelIcon style={{color: green[500]}}/>}
                                   onClick={loadLogosAndExportToExcel}>Export to Excel</Button></Grid>

                <Grid item>
                    <Select variant="outlined" color="primary"
                           input={<OutlinedInput margin='dense'/>}
                           value={pageSize}
                           onChange={ev => {
                               setPageSize(ev.target.value)
                               //  setFilteredPayrolls(props.filteredPayrolls.filter(p=>ev.target.value===0||p.bank===ev.target.value))
                               // payrollRun.filteredPayrolls=filteredPayrolls
                               //   props.onChange({type:ev.target.value,hrs})
                           }}
                >
                    <MenuItem key={0} value={"A4"}>A4</MenuItem>
                    <MenuItem key={1} value={"A3"}>A3</MenuItem>
                    <MenuItem key={2} value={"A2"}>A2</MenuItem>
                    <MenuItem key={3} value={null}>Fit All</MenuItem>
                </Select>
                </Grid>
                <Grid item>
                    <Select variant="outlined" color="primary"
                           input={<OutlinedInput margin='dense'/>}
                           value={pdfFontSize}
                           onChange={ev => {
                               setPdfFontSize(ev.target.value)
                           }}
                >
                    <MenuItem key={1} value={8}>8px</MenuItem>
                    <MenuItem key={2} value={10}>10px</MenuItem>
                    <MenuItem key={3} value={12}><strong>12px</strong></MenuItem>
                    <MenuItem key={4} value={14}>14px</MenuItem>
                    <MenuItem key={5} value={16}>16px</MenuItem>
                    <MenuItem key={6} value={18}>18px</MenuItem>
                </Select>
                    {/*<Autocomplete*/}
                    {/*    id="free-solo-demo"*/}
                    {/*    value={"25"}*/}
                    {/*    freeSolo*/}
                    {/*    options={['25','50','75','100']}*/}
                    {/*    renderInput={(params) => (*/}
                    {/*        <TextField   {...params} onChange={e=>console.log(e.target.value)} label="Page Scale %" margin="dense" variant="outlined" />*/}
                    {/*    )}*/}
                    {/*/>*/}


                    <Select variant="outlined" color="primary"
                            input={<OutlinedInput margin='dense'/>}
                            value={pageScale}
                            onChange={ev => {
                                setPageScale(ev.target.value)
                                //  setFilteredPayrolls(props.filteredPayrolls.filter(p=>ev.target.value===0||p.bank===ev.target.value))
                                // payrollRun.filteredPayrolls=filteredPayrolls
                                //   props.onChange({type:ev.target.value,hrs})
                            }}
                    >
                       <MenuItem key={1} value={0.15}>15%</MenuItem>
                        <MenuItem key={2} value={0.25}><strong>25%</strong></MenuItem>
                        <MenuItem key={3} value={0.3}>30%</MenuItem>
                        <MenuItem key={4} value={0.4}>40%</MenuItem>
                        <MenuItem key={5} value={0.45}>45%</MenuItem>
                        <MenuItem key={6} value={0.5}><strong>50%</strong></MenuItem>
                        <MenuItem key={7} value={0.6}>60%</MenuItem>
                        <MenuItem key={8} value={0.75}><strong>75%</strong></MenuItem>
                        <MenuItem key={9} value={0.9}><strong>90%</strong></MenuItem>
                        <MenuItem key={10} value={1}><strong>100%</strong></MenuItem>
                        <MenuItem key={11} value={1.5}>150%</MenuItem>
                    </Select>
                <Button variant="outlined" disabled={exporting} color="primary"
                           startIcon={<PrintIcon style={{color: red[500]}}/>} onClick={()=>{

                    exportPDF()
                }}>{exporting&&<CircularProgress disableShrink
                    style={{marginLeft: -30}} size={25}/>}Export
                    PDF</Button></Grid>
                <Grid item>
                    

                    <FormControlLabel
                        control={
                            <Switch
                                checked={showFooter}
                                onChange={ev=>setShowFooter(ev.target.checked)}
                                name="checkedB"
                                color="primary"
                            />
                        }
                        label="Show Footer"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={showJournal}
                                onChange={ev=>setShowJournal(ev.target.checked)}
                                name="checkedJ"
                                color="primary"
                            />
                        }
                        label="Show Journal"
                    />
                </Grid>
                <Grid item><Button variant="outlined" color="primary" startIcon={<SaveIcon style={{color: blue[500]}}/>}
                           onClick={()=>{
                             //  updateColumnsWidth();
                               saveColumns();
                           }}>  Save View</Button></Grid>
            </Grid>
            {/*<button*/}
            {/*    title="Export PDF"*/}
            {/*    className="k-button k-primary"*/}
            {/*    onClick={exportPDF}*/}
            {/*    disabled={exporting}*/}
            {/*>*/}
            {/*    Export PDF*/}
            {/*</button>*/}
        </GridToolbar>

        {
            columns.map((column, idx) =>
                column.show && (<Column
                    key={idx}
                    className={column.field}
                    field={column.field}
                    title={column.title}
                    width={columnSizes[column.field] || column.width}
                    format={column.format}
                    orderIndex={column.orderIndex}
                    cell={props=><MultiCurrencyCell {...props} scale={pageScale} pdf pdfFontSize={pdfFontSize} columns={columns} format={column.format}/>}
                    footerCell={column.field.includes("fullName")?props=><TotalCell {...props} pdfFontSize={pdfFontSize} pdf scale={pageScale}  count/>:column.format&&(props=><TotalCell pdfFontSize={pdfFontSize} scale={pageScale} {...props} pdf/>)}
                    headerCell={(props) => (
                        <DynamicHeaderCell {...props} pdf pageScale={pageScale} pdfFontSize={pdfFontSize} />
                      )}
                    filter={column.filter}
                    columnMenu={

                        props =>
                            <CustomColumnMenu
                                {...props}

                                filterOn={!!column.filter}
                                columns={columns}


                                initColumns={allColumns(templates,companySettings)}
                                onColumnsSubmit={onColumnsSubmit}
                            />
                    }
                />)
            )
        }
    </KGrid>


            </GridPDFExport>
        </div>
    );
};



class PageTemplate extends React.Component {

    render() {
        const {site,department,dateText,pageNum,totalPages,logo, stamp, footerItems, showFooter, status} = this.props;
        // if(pageNum===1)
        // {
            return <div>
                <div style={{ position: "absolute", top: "10px", left: "10px", width:"100%", color:"white", padding:"10px", backgroundColor:"#0260f7" }}>
                    <Grid container  style={{width:"100%"}}  >
                        <Grid item xs={2}>
                            {logo&&<img alt='company_logo' height={180} src={logo}/>}
                        </Grid>
                        <Grid item xs={8}  justify="center" alignContent="center" container direction="column"  >
                            <Grid item>
                                <span style={{fontSize:30,  fontWeight:"bolder", textJustify:"center"}} >{localStorage.getItem('companyName') }</span>

                            </Grid>
                            <Grid item>
                                <span style={{fontSize:35, padding:'10px', fontWeight:"bold",textJustify:"center"}}>{dateText} {site?` - ${site}`:''} {department?` - ${department}`:''} Payroll</span>

                            </Grid>

                        </Grid>


                        <Grid  item xs={1} >
                            <span style={{fontSize:30}} >Page {this.props.pageNum} of {this.props.totalPages}  </span>
                        </Grid>

  <Grid item xs={1} >
  <span>payday.et</span>
                        </Grid>


                    </Grid>

                </div>

                <div>

                <div
        style={{
          position: 'absolute',
          bottom: '100px',
          left: '20%'
        
         
        }}
      >

<div style={{  position: 'relative', left: '-20%'}}>
{showFooter?<Grid style={{fontSize:"2rem"}} justify="center" alignItems='center' container spacing={10}>

{
                               footerItems.map(fe => <Grid item>
                                <strong>{fe.field}</strong> : <span
                                style={{textDecoration: 'underline',zIndex:50}}>
                                    {
                                        typeof fe.value === 'string' || typeof fe.value === 'undefined' || fe.value === null
                                            ? (fe.value || '________') + '_______'
                                            : fe.value.map(i=>
                                                <span>
                                                    {i.name || '________'}_______
                                                    {i.sign && <img style={{marginLeft:-80, marginBottom: -50, zIndex:0}} alt='sign' src={i.sign} height={120} width={120} />}
                                                </span>
                                            )
                                    }
                                </span>
                                {fe.sign&&<img style={{marginLeft:-80, marginBottom: -50, zIndex:0}} alt='sign' src={fe.sign} height={120} width={120} />}
                            </Grid>
                            )
                        }

</Grid>:null}

</div>
<div style={{position: 'absolute', right:'50px', bottom:'-50px', zIndex:999}}>
    
    {status==='Approved'&&pageNum===totalPages&&stamp&&showFooter&&<img alt='stamp' src={stamp} height={'400px'} />}
</div>
           
      </div>
            

                <div
        style={{

          position: 'absolute',
          bottom: '10px',
          left: '10px',
          fontSize:"1.5rem"
        }}
      >
        Page {pageNum} of {totalPages}
      </div>
            </div>

                </div>

                
        

    }
}
export default PayrollSheetGrid;